import { FC, createElement, useCallback, useEffect, useState } from 'react';
import {
  DepartmentSections,
  DepartmentSectionsProps,
} from './department-sections';
import { useDepartmentSectionsQuery } from '../../hooks/department-sections-query';
import { useDepartmentSectionTypeByExternalIdsQuery } from '../../hooks/department-section-type-by-external-ids-query';
import { useMediaQuery } from '@plataformaxvia/design-system';
import { useHistory } from 'react-router-dom';
import {
  DepartmentSectionsProvider,
  useDepartmentSections,
} from './department-sections.context';
import { DepartmentSectionDistinctBy } from '../../apis/department';

const ITEMS_PER_PAGE = 8;
const EXPRESSO_CIDADAO_EXTERNAL_ID = 3;

interface DepartmentSectionsContainerProps {
  title: string;
}

const DepartmentSectionsInner: FC<DepartmentSectionsContainerProps> = ({
  title,
}) => {
  const { city, expressoOnly } = useDepartmentSections();
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { data: sectionTypeData } =
    useDepartmentSectionTypeByExternalIdsQuery({
      externalIds: [EXPRESSO_CIDADAO_EXTERNAL_ID],
    });

  const { data, isLoading } = useDepartmentSectionsQuery({
    limit: ITEMS_PER_PAGE,
    offset: (currentPage - 1) * ITEMS_PER_PAGE,
    city: city ?? undefined,
    departmentSectionTypeId: expressoOnly
      ? sectionTypeData?.[0]?.id
      : undefined,
    distinctBy: [DepartmentSectionDistinctBy.EXTERNAL_ID, DepartmentSectionDistinctBy.SHARED_DEPARTMENT_SECTION_EXTERNAL_ID],
    resolveSharedReferences: true,
    orderBy: 'name:ASC',
  });

  const sections = data?.departmentSections ?? [];
  const totalPages = Math.ceil((data?.metadata?.total ?? 0) / ITEMS_PER_PAGE);

  useEffect(() => {
    setCurrentPage(1);
  }, [city, expressoOnly]);

  const handleInfoClick = useCallback(
    (departmentSectionId: string) => {
      const pathname = `/carta-de-servicos/atendimento-presencial/${departmentSectionId}`;
      history.push(pathname);

      window.parent.dispatchEvent(
        new CustomEvent('catalog:navigation', {
          detail: {
            pathname: `/app/catalog${pathname}`,
            search: '',
            source: 'catalog',
          },
        })
      );
    },
    [history]
  );

  const props: DepartmentSectionsProps = {
    title,
    sections,
    isLoading,
    currentPage,
    totalPages,
    setCurrentPage,
    onClickInfo: handleInfoClick,
    isMobile,
  };

  return createElement(DepartmentSections, props);
};

export const DepartmentSectionsContainer: FC<DepartmentSectionsContainerProps> =
  (props) =>
    createElement(
      DepartmentSectionsProvider,
      null,
      createElement(DepartmentSectionsInner, props)
    );
